import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/Layout';
import ErrorDisplay from './components/ErrorDisplay';
import ConnectionInfo from './components/ConnectionInfo';
import useStore from './store/useStore';
import { api } from './api/client';
import AnimatedRoutes from './components/AnimatedRoutes';

function App() {
  const { apiError, setApiError, clearApiError } = useStore();

  useEffect(() => {
    // Глобальный обработчик ошибок API
    const responseInterceptor = api.interceptors.response.use(
      (response) => response,
      (error) => {
        // Показываем ошибку только для сетевых проблем
        if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED' || !error.response) {
          setApiError(error);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [setApiError]);

  const handleRetry = () => {
    clearApiError();
    // Перезагружаем страницу для повторной попытки
    window.location.reload();
  };

  return (
    <Router>
      <Layout>
        <AnimatedRoutes />
      </Layout>
      
      {/* Глобальное отображение ошибок */}
      <ErrorDisplay 
        error={apiError} 
        onClose={clearApiError}
        onRetry={handleRetry}
      />
      
      {/* Информация о подключении */}
      {/* <ConnectionInfo /> */}
    </Router>
  );
}

export default App;

